import { UpdateGroupComponent } from './update.groups/update.groups.component';
import { UpdateUpdaterComponent } from './update.updater/update.updater.component';
import { AuthGuardService } from '../services/auth-guard.service';
import { DashboardView } from '../views/dashboard/dashboard.view';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UpdateCPUBenchmarksComponent } from './update.cpubenchmarks/update.cpubenchmarks.component';
import { UpdateGPUBenchmarksComponent } from './update.gpubenchmarks/update.gpubenchmarks.component';
import { UpdateCommandCenterComponent } from './update.commandcenter/update.commandcenter.component';

const UpdateComposerRouting: Routes = [
    // login view
    {
        path: 'update', canActivate: [AuthGuardService], component: DashboardView,
        children: [
            // handle all other routes
            { path: 'updater', component: UpdateUpdaterComponent },
            { path: 'groups', component: UpdateGroupComponent },
            { path: 'cpubenchmarks', component: UpdateCPUBenchmarksComponent },
            { path: 'gpubenchmarks', component: UpdateGPUBenchmarksComponent },
            { path: 'commandcenter', component: UpdateCommandCenterComponent },
            { path: '**', component: UpdateUpdaterComponent }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(UpdateComposerRouting)],
    exports: [RouterModule]
})
export class UpdaterRoutingModule { }
